import { ColumnType } from '@import/interfaces';

/**
 * Given the HumiColumns(ColumnType) this function will return
 * whether or not columns required together all have values
 */
export const validateRequiredWithConstraints = (sectionHumiColumns: ColumnType[]): boolean => {
    const columnsRequiredWith = sectionHumiColumns.filter(
        (humiColumn: ColumnType) =>
            humiColumn.requiredWith &&
            humiColumn.requiredWith.some((requiredColumn) => humiColumn.serializeName.includes(requiredColumn))
    );

    return columnsRequiredWith.every((requiredColumns: ColumnType) => {
        const hasMappingAndConditionallyRequired = requiredColumns.csvColumn && requiredColumns.conditionallyRequired;
        const hasNoMappingAndNotConditionallyRequired =
            !requiredColumns.csvColumn && !requiredColumns.conditionallyRequired;
        return hasMappingAndConditionallyRequired || hasNoMappingAndNotConditionallyRequired;
    });
};
